// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 329 ? "60583757" : chunkId) + "." + {"119":"92fb098108e48bc5","329":"e8c9c4a25f6457d3"}[chunkId] + ".js";
};